// 后端微服务端口名
export const SYSTEM = ''
export const APP = '/app'
export const ADMIN = '/admin'
export const ORDER = '/order'
export const GOODS = '/goods'
export const PAY = '/pay'
